import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getErrorList, getErrorLogs } from "@/api/logs";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menuWidth: 120,
        dialogType: 'drawer',
        column: [{
          label: "服务id",
          prop: "serviceId",
          search: true,
          width: '120'
        }, {
          label: "服务host",
          prop: "serverHost",
          search: true,
          width: '150'
        }, {
          label: "服务ip",
          prop: "serverIp",
          width: '160'
        }, {
          label: "软件环境",
          prop: "env",
          width: '80'
        }, {
          label: "请求方法",
          prop: "method",
          width: '80'
        }, {
          label: "请求接口",
          prop: "requestUri"
        }, {
          label: "日志时间",
          prop: "createTime",
          width: '180'
        }, {
          label: "用户代理",
          prop: "userAgent",
          span: 24,
          hide: true
        }, {
          label: "请求数据",
          prop: "params",
          type: "textarea",
          span: 24,
          minRows: 2,
          hide: true
        }, {
          label: "日志数据",
          prop: "stackTrace",
          type: "textarea",
          span: 24,
          minRows: 16,
          hide: true
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.log_error_view, false)
      };
    }
  }),
  methods: {
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this = this;

      if (["edit", "view"].includes(type)) {
        getErrorLogs(this.form.id).then(function (res) {
          _this.form = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this2 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getErrorList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this2.page.total = data.total;
        _this2.data = data.records;
        _this2.loading = false;
      });
    }
  }
};